exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tag {\n    padding: 6px 12px;\n    display: block;\n    float: left;\n    background: #eee;\n    margin: 0 2px 2px 0px;\n    cursor: default;\n}\n\n.tag button {\n    border: none;\n    background: transparent;\n    padding: 0;\n    margin: 0;\n}\n\n.tag button:focus {\n    outline: none;\n}\n\n.form-control {\n    /*display: flex;*/\n    display: -webkit-box;\n}\n\n.invisible-control {\n    background: transparent;\n    height: 32px;\n    border: none;\n    /*padding: 10px 0 0 6px;*/\n    /*width: 100%;*/\n    /*flex: 1;*/\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/jordan/stunii-cms-stunii-cms-Appzorro1/stunii-cms-stunii-cms-Appzorro1/src/app/components/chips/chips.component.css
// module id = ../../../../../src/app/components/chips/chips.component.css
// module chunks = main